import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { getBillFile, uploadBillFile, uploadBillFileConfirm } from "./services";

export const useUploadBillFileMutation = () =>
  useMutation({
    mutationFn: uploadBillFile,
    onSuccess: (_response, { jointBillServiceId }) =>
      queryClient.invalidateQueries({
        queryKey: ["jointBillServicePeriodData", jointBillServiceId],
      }),
  });

export const useUploadBillFileConfirmMutation = () =>
  useMutation({
    mutationFn: uploadBillFileConfirm,
    onSuccess: (_response, { jointBillServiceId }) =>
      queryClient.invalidateQueries({
        queryKey: ["jointBillServicePeriodData", jointBillServiceId],
      }),
  });

export const useGetBillFileMutation = () =>
  useMutation({
    mutationFn: getBillFile,
  });
